/**
 * @title payment-methods.js: Sub-module for Account pages
 * @description This module is used to handle tasks on Account -> Payment Methods page
 * @dependency checkout_helper, creditcard
 */
define(['checkout_helper', 'creditcard'], function(checkoutHelper, creditCard) {
  let PaymentMethods = {
    sessionId: '',
    isACHMember: $('#achMemberValue').val() == 'true',

	getForm: function() {
  	return $('#PaymentMethodForm');
  },
  
  url: {
  	AJAX_PAYMENT_METHOD_UPDATE: '/AjaxPaymentMethodUpdateCmd'
  },
    /**
     * Initialization of the module.
     */
    init: function() {
    	this.cybersourceEnabled = $("#cybersourceEnabled").val() == 'true';
    	this.addValidationMethods();
    	this.initValidation();
    	this.maskInput();
		COSTCO.MemberVerification.validationRules()
    	if ((isBDApplication !== 'BD' || (isBDApplication === 'BD' && !PaymentMethods.isACHMember)) && this.getForm().length > 0) {
    		this.showCCSection();
    	}
		console.log('Payment Methods module initialized.');
    },

    /**
     * Adds validation methods for form validation
     */
    addValidationMethods: function() {
		$.validator.setDefaults({
			ignore: '.ignore',
		});
	
		$.validator.addMethod('costcoCC', function(value, element) {
			value = value.replace(/\s+/g, '');
			var costcoCCSaved = $('#costcoCCSaved').val() == 'true';
			//check to see if value is costco cc and is disabled, otherwise return true and do normal customcc check.
			if (/^\*/.test(value) && costcoCCSaved || /^7\d{5}\*{6}\d{4}$/.test(value)) {
				var costcoCCDisabled = $('#costcoCCDisabled').val() == 'true';
				return !costcoCCDisabled;
			}
			return true;
		});
		
		/**
     	* Replicated $.validator.methods.creditcard() from jquery-1.10.2 for jquery-3.6.3
		* since this is no longer defined in 3.6.3
		* ALM 47081
     	*/
		 $.validator.addMethod('rxCreditCard', function(value, element) {
			if (this.optional(element)) {
                return "dependency-mismatch";
            }
            if (/[^0-9 \-]+/.test(value)) {
                return false;
            }
            var n = 0, i = 0, r = false, s, o;
            value = value.replace(/\D/g, "");
            if (value.length < 13 || value.length > 19) {
                return false;
            }
            for (s = value.length - 1; s >= 0; s--) {
                o = value.charAt(s);
                i = parseInt(o, 10);
                if (r) {
                    if ((i *= 2) > 9) {
                        i -= 9;
                    }
                }
                n += i;
                r = !r;
            }
            return n % 10 === 0;
		});

		$.validator.addMethod('customcc', function(value, element) {
			value = value.replace(/\s+/g, '');
			if(!costcoStoreFeatures.DISCOVER_DINERSCLUB_JCB_CUP_ENABLED 
					&& (isBDApplication == 'BC' && COSTCO.util.getLocale() == 'en-US')) {
				if(/^6011\d{2}\*{6}\d{4}$/.test(value) || /^65\d{4}\*{6}\d{4}$/.test(value) || /^6499\d{2}\*{6}\d{4}$/.test(value) || /^6555\d{2}\*{6}\d{4}$/.test(value) || /^6556\d{2}\*{6}\d{4}$/.test(value) || /^(30[0-5]|3095|36[0-9]|3[8-9])/.test(value) || /^(3528|35[3-8]|333[7-9]|334)/.test(value)) {
					return false;
				} 
			}
			if(COSTCO.util.getLocale() == 'en-CA' || COSTCO.util.getLocale() == 'fr-CA' || isBDApplication == 'BD'){
				if(/^6011\d{2}\*{6}\d{4}$/.test(value) || /^65\d{4}\*{6}\d{4}$/.test(value) || /^6499\d{2}\*{6}\d{4}$/.test(value) || /^6555\d{2}\*{6}\d{4}$/.test(value) || /^6556\d{2}\*{6}\d{4}$/.test(value) || /^(30[0-5]|3095|36[0-9]|3[8-9])/.test(value) || /^(3528|35[3-8]|333[7-9]|334)/.test(value)) {
					return false;
				} 
			}
			
			if (value.indexOf('*') > 0 && value.length >= 14 && value.length <= 16) {
				return true;
			}
			return this.optional(element) || /^7\d{5}\*{6}\d{4}$/.test(value) || /^\S{6}(\*{3}|\*{5})\s?\d{4}$/.test(value) || /^\S{6}\*{6}\s?\d{4}$/.test(value) || $.validator.methods.rxCreditCard.call($.data(element.form, 'validator'), value, element);
		});

		$.validator.addMethod('checkSpecialchar', function(value, element) {
			// CC name shouldn't have any non-alphanumeric characters and needs at least 1 letter				
			return this.optional(element) || (!COSTCO.util.CC_NAME_FIELD_REGEX.test(value) && COSTCO.util.ATLEAST_ONE_ALPHABET.test(value));
		 });

		$.validator.addMethod('checkExpiryDate', function(value, element) {
			return this.optional(element) || (/^(0[1-9]|1[012])\/([123]\d)$/).test(value);
		});
	
		$.validator.addMethod("checkIsDateInPast", function(value, element) {
			let enteredMonth = parseInt(value.split('/')[0]);
			let enteredYear = parseInt(value.split('/')[1]);
			let now = new Date();
			let currentMonth = parseInt((now.getMonth() + 1).toString());
			let currentYear = parseInt(now.getFullYear().toString().substr(-2));
			if (enteredYear < currentYear || (enteredYear == currentYear && enteredMonth < currentMonth)) {
				return false;
			} else{
				return true;
			}
		});
		
		$.validator.addMethod("achtype", function(value, element, param) {
			return this.optional(element) || value !== param;
		  }, "Value must not equal arg.");
		
		$.validator.addMethod("achNoSpChar", function(value, element, param) {
		  value = value.replace(/\s+/g,"");				
		  return this.optional(element) || /^\w+$/i.test(value);			
		  }, messages.ERR_INVALID_ACH_SPECIAL_CHARACTERS);
		
		$.validator.addMethod("achAccountNumber", function(value, element, param) {
			return this.optional(element) || /^(\d{1,13}|\*{1,13}|\x{1,13})\d{4}$/.test(value);			
		}, messages.ERR_INVALID_ACCOUNTNUM);
		
		$.validator.addMethod("achRoutingNumber", function(value, element, param) {
			return this.optional(element) || /^\d{9}$/.test(value);			
		}, messages.ERR_INVALID_ROUTINGNUM);
		
		$.validator.addMethod("achNameLen", function(value, element, param) {
		  return this.optional(element) || value.length ==0 || value.length < 29;			
		  }, messages.ERR_INVALID_ACH_NAME);
	},
    validationRules: function() {
      $.validator.setDefaults({
        ignore: '.ignore',
      });

      $.validator.addMethod('costcoCC', function(value, element) {
    	  value = value.replace(/\s+/g, '');
    	  var costcoCCSaved = $('#costcoCCSaved').val() == 'true';
    	  //check to see if value is costco cc and is disabled, otherwise return true and do normal customcc check.
    	  if (/^\*/.test(value) && costcoCCSaved || /^7\d{5}\*{6}\d{4}$/.test(value)) {
    		  var costcoCCDisabled = $('#costcoCCDisabled').val() == 'true';
	          return !costcoCCDisabled;
    	  }
    	  return true;
      });

      $.validator.addMethod('customcc', function(value, element) {
        value = value.replace(/\s+/g, '');

        if (value.indexOf('*') > 0 && value.length == 16) {
          return true;
        }

        return this.optional(element) || /^7\d{5}\*{6}\d{4}$/.test(value) || /^\S{6}(\*{3}|\*{5})\s?\d{4}$/.test(value) || /^\S{6}\*{6}\s?\d{4}$/.test(value) || $.validator.methods.creditcard.call($.data(element.form, 'validator'), value, element);
      });

      $.validator.addMethod('checkSpecialchar', function(value, element) {
        return this.optional(element) || !(/[<>\'\"]/).test(value); // CC name shouldn't have any html tag
      });

      $.validator.addMethod('checkExpiryDate', function(value, element) {
        return this.optional(element) || (/^(0[1-9]|1[012])\/([123]\d)$/).test(value);
      });

	  $.validator.addMethod("checkIsDateInPast", function(value, element ) {
		  let enteredMonth = parseInt(value.split('/')[0]);
		  let enteredYear = parseInt(value.split('/')[1]);
		  let now = new Date();
		  let currentMonth = parseInt((now.getMonth() + 1).toString());
		  let currentYear = parseInt(now.getFullYear().toString().substr(-2));
		  if (enteredYear < currentYear || (enteredYear == currentYear && enteredMonth < currentMonth)) {
			  return false;
		  } 
		  else{
			  return true;
		  }
	   });
    },
    /**
     * Initializes jQuery validation plugin on PaymentMethod form
     */
    initValidation: function() {
    	PaymentMethods.getForm().validate({
			  errorPlacement: function(error, element) {
		        	if ($(element).is('#card_number_validator')) {
		        		$('.gw-proxy-number').css('border','');
		        		$('.gw-proxy-number').addClass('tokenization-error');
		        		error.insertAfter(element);
		        	} else if (element.attr("name") == "ach_checkbox" ) {
		        		element.closest(".row").find("[ach-checkbox-error]").append(error); 
		        	} else if ($(element).is('#ach_account_holder_validator')) {
		        		$('.gw-proxy-bankAccountHolder').css('border','');
		        		$('.gw-proxy-bankAccountHolder').addClass('tokenization-error');
		        		error.insertAfter(element);
		        	} else if ($(element).is('#ach_routing_number_validator')) {
		        		$('.gw-proxy-routingNumber').css('border','');
		        		$('.gw-proxy-routingNumber').addClass('tokenization-error');
		        		error.insertAfter(element);
		        	} else if ($(element).is('#ach_account_number_validator')) {
		        		$('.gw-proxy-bankAccountNumber').css('border','');
		        		$('.gw-proxy-bankAccountNumber').addClass('tokenization-error');
		        		error.insertAfter(element);
		        	} else {
		        		error.insertAfter(element);
		        	}
		        },
		        success: function(label, element) {
		        	if ($(element).is('#card_number_validator')) {
		        		$('.gw-proxy-number').css('border','1px solid #ccc');
		        		$('.gw-proxy-number').removeClass('tokenization-error');
		        	} else if ($(element).is('#ach_account_holder_validator')) {
		        		$('.gw-proxy-bankAccountHolder').css('border','1px solid #ccc');
		        		$('.gw-proxy-bankAccountHolder').removeClass('tokenization-error');
		        	} else if ($(element).is('#ach_routing_number_validator')) {
		        		$('.gw-proxy-routingNumber').css('border','1px solid #ccc');
		        		$('.gw-proxy-routingNumber').removeClass('tokenization-error');
		        	} else if ($(element).is('#ach_account_number_validator')) {
		        		$('.gw-proxy-bankAccountNumber').css('border','1px solid #ccc');
		        		$('.gw-proxy-bankAccountNumber').removeClass('tokenization-error');
		        	}
		        }
    	});
    },
    /**
     * Removes red borders from input fields
     */
    removeBorderErrors: function() {
    	PaymentMethods.getForm().find('iframe.tokenization-error, input.error').each(function(index, element) {
    		$(element).css('border','1px solid #ccc');
    		$(element).removeClass('tokenization-error, error');
    	});
    },
    /**
     * Disables/enables input fields according to selected payment method
     * @param paymentMethodType payment method type (CreditCard | ACH)
     * @return void
     */
    setupSelectedFormSection: function(paymentMethodType) {
    	let achInputFields = PaymentMethods.getForm().find('input[ach-input-field]');
		let ccInputFields = PaymentMethods.getForm().find('input[cc-input-field]');
		
    	if (paymentMethodType === 'CreditCard') {
    		achInputFields.each(function() {
    			$(this).attr('disabled','disabled');
    		});
    		ccInputFields.each(function() {
    			$(this).removeAttr('disabled');
    		});
    		
    	} else if (paymentMethodType === 'ACH') {
    		achInputFields.each(function() {
    			$(this).removeAttr('disabled');
    		});
    		ccInputFields.each(function() {
    			$(this).attr('disabled','disabled');
    		});
    		
    	} else {
    		console.log('Unknown payment method passed to setupSelectedFormSection() function.');
    	}
    	PaymentMethods.getForm().validate().resetForm();
    },
    /**
     * Validates the Payment Methods add/edit fields
     */
    validatePaymentMethodForm: function() {
      let form = PaymentMethods.getForm();

      if (form.length != 0) {
        return form.valid();
      }
    },
    /**
     * Validation rules for credit card input fields
     */
	creditCardValidationRules: {
	    number: {
	      required: true,
	      customcc: true,
	      costcoCC: true,
	      messages: {
	    	  required: messages.ERR_CCNUM_REQ,
	          customcc: messages.ERR_INVALID_CREDITCARD_SHORT,
	          costcoCC: messages.COSTCO_CC_DISABLED
	      }
	    },
	    nameOnCard: {
	      required: true,
	      checkSpecialchar: true,
	      messages: {
	    	  required: messages.ERR_NAME_REQ,
	          checkSpecialchar: messages.ERR_INVALID_CC_NAME
	      }
	    },
	    cc_expiry_date: {
	      required: true,
	      checkExpiryDate: true,
	      checkIsDateInPast: true,
	      messages: {
	    	  required: messages.ERR_EXPIRYDATE_REQ,
	          checkExpiryDate: messages.ACCOUNT_PAYMENT_METHODS_ERR_INVALID_DATE,
	          checkIsDateInPast: messages.ERR_INVALID_PAST_DATE
	      }
	    }
	},
	pharmacyCreditCardValidationRules: {
	    number: {
	      required: true,
	      customcc: true,
	      costcoCC: true,
	      messages: {
	    	  required: messages.ERR_PH_CCNUM_REQ,
	          customcc: messages.ERR_INVALID_PH_CREDITCARD_SHORT,
	          costcoCC: messages.COSTCO_CC_DISABLED
	      }
	    },
	    nameOnCard: {
	      required: true,
	      checkSpecialchar: true,
	      messages: {
	    	  required: messages.ERR_PH_NAME_REQ,
	          checkSpecialchar: messages.ERR_INVALID_CC_NAME
	      }
	    },
	    cc_expiry_date: {
	      required: true,
	      checkExpiryDate: true,
	      checkIsDateInPast: true,
	      messages: {
	    	  required: messages.ERR_PH_EXPIRYDATE_REQ,
	          checkExpiryDate: messages.ACCOUNT_PAYMENT_METHODS_ERR_INVALID_DATE,
	          checkIsDateInPast: messages.ERR_INVALID_PAST_DATE
	      }
	    }
	},
    /**
     * Validation rules for ACH input fields
     */
    achValidationRules: {
         ach_account_holder: {
        	required: true,
  	   		achNameLen: true,
  	   		messages: {
        	    required: messages.ERR_ACH_NAME_REQ,
        	    achNameLen: messages.ERR_INVALID_ACH_NAME
        	    }
         },
         accountType: {
    	   	required: true,
   			achtype: "-1",
   			messages: {
   				required: messages.ERR_ACH_CARDTYPE_REQ,
   				achtype: messages.ERR_ACH_CARDTYPE_REQ
   			}
         },
       ach_routing_number: {
    	   	required: true,
   			achNoSpChar: true,
   			achRoutingNumber: true,
   			messages: {
   				required: messages.ERR_ROUTINGNUM_REQ,
   				achNoSpChar: messages.ERR_INVALID_ROUTINGNUM
   			}
         },
         ach_account_number: {
        	 required: true,
        	 achAccountNumber: true,
        	 messages: {
        		required: messages.ERR_ACH_CCNUM_REQ,
        	    achNoSpChar: messages.ERR_INVALID_ACCOUNTNUM,
        	    achAccountNumber: messages.ERR_INVALID_ACCOUNTNUM
        	 }
         },
         ach_checkbox: {
        	 required: true,
        	 messages: {
        		required: messages.ACH_AGREE_PROMPT
        	 }
         },
    },
    /**
     * Validation rules for ACH input fields
     */
    achCybsValidationRules: {
    	ach_account_holder: {
        	required: true,
  	   		achNameLen: true,
  	   		messages: {
        	    required: messages.ERR_ACH_NAME_REQ,
        	    achNameLen: messages.ERR_INVALID_ACH_NAME
        	    }
         },
    	accountType: {
    	   	required: true,
   			achtype: "-1",
   			messages: {
   				required: messages.ERR_ACH_CARDTYPE_REQ,
   				achtype: messages.ERR_ACH_CARDTYPE_REQ
   			}
         },
         ach_checkbox: {
        	 required: true,
        	 messages: {
        		required: messages.ACH_AGREE_PROMPT
        	 }
         },
    },
    /**
     * Helper function to remove rules from form input fields
     */
    removeRules: function(rulesObj) {
        for (var item in rulesObj) {
        	if (item == 'accountType') {
        		if ($('select[name='+ item + ']').length > 0) {
        			$('select[name='+ item + ']').rules('remove');
        		}
        	} else {
        		if ($('input[name='+ item + ']').length > 0) {
        			$('input[name='+ item + ']').rules('remove');
        		}
        	}
            
        } 
    },
    /**
     * Helper function to add rules to form input fields
     */
    addRules: function(rulesObj) {
        for (var item in rulesObj) {
        	if (item == 'accountType') {
        		$('select[name='+ item + ']').rules('add',rulesObj[item]);  
        	} else {
        		$('input[name='+ item + ']').rules('add',rulesObj[item]);  
        	}
        	
        } 
    },
    /**
     * Submits the Payment Methods add/edit form
     */
    submit: function(redirectURL) {
      let form = PaymentMethods.getForm();
      let expDate = $(form).find('input[name=cc_expiry_date]').val().split('/');
      $(form).find('input[name=expMonth]').val(expDate[0]);
      $(form).find('input[name=expYear]').val('20' + expDate[1]);
      if(PaymentMethods.cybersourceEnabled) {
	      $(form).find('input[name=ach_account_holder]').val($("#ach_account_holder").val());
	      $("#ach_account_holder_validator").val($("#ach_account_holder").val());
      }
      checkoutHelper.ajax_update_state({
        method: 'POST',
        url: PaymentMethods.url.AJAX_PAYMENT_METHOD_UPDATE,
        data: form.serializeArray(),
        dataType: 'json',

        done: function(data, textStatus, jqXHR, options) {
          checkoutHelper.ajax_update_default_done(data, textStatus, jqXHR, options);

          if (data.error.application.length > 0) {
            COSTCO.util.notification.displayNotification(COSTCO.util.notification.type.ERROR, [data.error.application], true);
            
          } else if (data.payload.data.status === 'success') {
        	  COSTCO.util.notification.displayNotification(COSTCO.util.notification.type.SUCCESS, [data.payload.data.message], true);
        	  if (redirectURL) {
              	setTimeout(function() {
              		location.href = COSTCO.util.makeUrl('/' + redirectURL, {langId: wcs.langId, storeId: wcs.storeId, catalogId: wcs.catalogId, toPrescription: true});
              	}, 2000);
              	
          }
          }
        },
        always: function() {
          $('.order-ajax').removeClass('ajax-busy');
          TokenGateway.refreshGateway();
        },
      });
    },
    /**
     * Mask expiry date and credit card number
     */
    maskInput: function() {
      $('#cc_expiry_date').mask('00/00');
      $('#card_number').mask('ZZZZ ZZZZ ZZZZ 0000', {
        selectOnFocus: true,
        translation: {
          'Z': {
            pattern: '[\\*0-9]',
          },
        },
      });
    },

    formSubmitter: function(redirectURL, paymentMethodType) {
      COSTCO.PaymentMethods.validatePaymentMethodForm();
      let form = PaymentMethods.getForm();
      if (form.valid()) {
        PaymentMethods.submit(redirectURL);
      }
    },
    
    /**
     * Removes the payment method from respective payment methods list
     * @param  {String} bodyMessage   	message to be displayed in body of dialog modal
     * @param  {String} form 			form to be submitted thru ajax
     * @param  {String} redirectURL 	URL to redirect the user to
     * @param  {String} type 			payment type (currently: 'CreditCard'|'ACH')
     * @return void
     */
    removePaymentMethod: function(bodyMessage, form, redirectURL, type) {
		COSTCO.dialog.createExtDialogBox({
			title: (type === 'CreditCard') ? messages.ACCOUNT_PAYMENT_METHODS_Remove_Card_Button_Text : messages.COSTCO_REMOVE,
			body: bodyMessage,
			primary: (type === 'CreditCard') ? messages.ACCOUNT_PAYMENT_METHODS_Remove_Card_Button_Text : messages.COSTCO_REMOVE,
			secondary: messages.JS_DIALOG_CANCEL,
			dialogclasses: 'remove-card-modal',
			primary_event: function() {
				checkoutHelper.ajax_update_state({
					method: 'POST',
					url: PaymentMethods.url.AJAX_PAYMENT_METHOD_UPDATE,
					data: $(form).serializeArray(),
					dataType: 'json',
					ajax_update_post_done: function(data) {
						
						// TODO: Check if we need this
						if(PaymentMethods.cybersourceEnabled) {
							createTokenSessionId();
						} else {
							TokenGateway.refreshGateway();
						}
						
						PaymentMethods.addValidationMethods();
						PaymentMethods.initValidation();
						PaymentMethods.maskInput();
						
						if (isBDApplication !== 'BD' || (isBDApplication === 'BD' && !PaymentMethods.isACHMember)) {
							PaymentMethods.showCCSection();
						}

						COSTCO.dialog.close();

						if (data.payload.data.status === 'success') {
							COSTCO.util.notification.displayNotification(COSTCO.util.notification.type.SUCCESS, [data.payload.data.message], true);
							if (redirectURL) {
								setTimeout(function() {
									location.href = COSTCO.util.makeUrl('/' + redirectURL, {langId: wcs.langId, storeId: wcs.storeId, catalogId: wcs.catalogId});
								}, 2000);
							}
						} else { // error
							COSTCO.util.notification.displayNotification(COSTCO.util.notification.type.ERROR, [data.payload.data.message], true);
						}
					}
				});
			}
		});
    },
    showRecaptchaDetails: function() {
		$('#cc-recaptcha-learn-more-link').addClass('hide');
		$('#recaptcha-message-top').focus();
	},
	
	/** Method to call validation method of recaptcha */
	validateReCaptcha: function(grecaptcha){
		grecaptcha.execute();	
	},
    /**
     * Saves payment method for a user
     * @param {redirectURL} URL to redirect the user to
     * @param {paymentMethodType} 'CreditCard'|'ACH'
     * @return void
     */
    savePaymentMethod: function(redirectURL, paymentMethodType) {
    	
    	//reset ach dropdown value
    	if ($('#ach_account_type').val()==null || $('#ach_account_type').val() == '') {
			$('#ach_account_type').val('-1');
    	}
    	
    	if (paymentMethodType === 'CreditCard') {
    		TokenGateway.updateSessionFromForm('card', function() {
        		COSTCO.PaymentMethods.formSubmitter(redirectURL, paymentMethodType);
        	}, 'PaymentMethodForm');
    		
    	} else if (paymentMethodType === 'ACH') {
    		
    		if ($('#ach_account_type').val() == '-1') {
    			$('#ach_account_type').val('');
    		}
    		TokenGateway.updateSessionFromForm('ach', function() {
        		COSTCO.PaymentMethods.formSubmitter(redirectURL, paymentMethodType);
        	}, 'PaymentMethodForm');
    	}
    	
    	//Add new payment methods here
    	return false;
    },
				    setlabelActive : function(data, type) {

					if ($('#cc-payment-block').find(
							'[id=card_number_validator]').val() != '') {
						$('label[for="card_number_validator"]').addClass(
								"active");

					}
					if ($('#cc-payment-block').find(
							'[id=cc_expiry_date]').val() != '') {
						$('label[for="cc_expiry_date"]').addClass("active");
					}
					if ($('#cc-payment-block').find(
							'[id=nameOnCard]').val() != '') {
						$('label[for="nameOnCard"]').addClass("active");
					}
				},
    /**
     * Displays credit card / ach payment form when widget in Display mode
     * @param  {JSON Object} data	data to populate template
     * @return {void}
     */
    showPharmacyPaymentForm: function(data, type) {
      COSTCO.util.notification.clearNotification();
      
      if(!this.cybersourceEnabled) {
    	  createTokenSessionId(false, false);
      }
      let formHtmlBlock = '#payment-method-edit';
      let formTemplate = 'tmpl_payment_methods_form';
      let inputFieldsSection = '';
      $('#payment-method-display').hide();

      let htmlForm = COSTCO.util.tmpl(formTemplate, {});
      $(formHtmlBlock).html(htmlForm);
      
      inputFieldsSection = COSTCO.util.tmpl('tmpl_pharmacy_payment_methods_full', data);
      $('#payment-method-container').append(inputFieldsSection);

      if(!this.cybersourceEnabled) {
    	 TokenGateway.refreshGateway();
      }	
           
      PaymentMethods.addValidationMethods();
      PaymentMethods.initValidation();
      PaymentMethods.maskInput();
      PaymentMethods.setlabelActive();
      
      if (type === 'CreditCard') {
    	  PaymentMethods.showCCSection();
      } else if (type === 'ACH') {
    	  PaymentMethods.showACHSection();
      }
      
      if(this.cybersourceEnabled) {
    	  this.setInputFieldsEvents();
      }
      
    },
    /**
     * Displays credit card / ach payment form when widget in Display mode
     * @param  {JSON Object} data	data to populate template
     * @return {void}
     */
    showPaymentForm: function(data, type) {
    	
      COSTCO.util.notification.clearNotification();
      if(!this.cybersourceEnabled) {
    	  createTokenSessionId(false, false);
      }
      let formHtmlBlock = '#payment-method-edit';
      let formTemplate = 'tmpl_payment_methods_form';
      let inputFieldsSection = '';
      $('#payment-method-display').hide();

      let htmlForm = COSTCO.util.tmpl(formTemplate, {});
      $(formHtmlBlock).html(htmlForm);
      
      inputFieldsSection = COSTCO.util.tmpl('tmpl_payment_methods_full', data);
      $('#payment-method-container').append(inputFieldsSection);
      
      if(!this.cybersourceEnabled) {
    	  TokenGateway.refreshGateway();
      }
      
      PaymentMethods.addValidationMethods();
      PaymentMethods.initValidation();
      PaymentMethods.maskInput();
      
      if (type === 'CreditCard') {
    	  PaymentMethods.showCCSection();
    	  if(this.cybersourceEnabled) {
        	  this.setInputFieldsEvents();
          }
      } else if (type === 'ACH') {
    	  PaymentMethods.showACHSection();
    	  if(this.cybersourceEnabled) {
        	  this.setACHInputFieldsEvents();
          }
      }
      
    },
    
    setInputFieldsEvents: function() {
    	$("#card_number").keypress(function(){
    		TokenGateway.resetCardNumber(this);
    	}).keyup(function(event){
    		if(event.keyCode === 8 || event.keyCode === 46){
    			TokenGateway.resetCardNumber(this);
    		}
    	});
    	$("#card_number").click(function(){
    		TokenGateway.resetCardNumber(this);
    	});
    },
    
    setACHInputFieldsEvents: function() {
    	$("#ach_account_number").keypress(function(){
    		TokenGateway.resetACHFields(this, $("#ach_routing_number"), "ach_account_number");
    	}).keyup(function(event){
    		if(event.keyCode === 8 || event.keyCode === 46){
    			TokenGateway.resetACHFields(this, $("#ach_routing_number"), "ach_account_number");
    		}
    	});
    	$("#ach_account_number").click(function(){
    		TokenGateway.resetACHFields(this, $("#ach_routing_number"), "ach_account_number");
    	});
    	
    	$("#ach_routing_number").keypress(function(){
    		TokenGateway.resetACHFields($("#ach_account_number"), this, "ach_routing_number");
    	}).keyup(function(event){
    		if(event.keyCode === 8 || event.keyCode === 46){
    			TokenGateway.resetACHFields($("#ach_account_number"), this, "ach_routing_number");
    		}
    	});
    	$("#ach_routing_number").click(function(){
    		TokenGateway.resetACHFields($("#ach_account_number"), this, "ach_routing_number");
    	});
    	$("#ach_account_holder").keypress(function(){
    		PaymentMethods.resetAccountHolderField();
    	}).keyup(function(event){
    		if(event.keyCode === 8 || event.keyCode === 46){
    			PaymentMethods.resetAccountHolderField();
    		}
    	});
    	$("#ach_account_holder").click(function(){
    		PaymentMethods.resetAccountHolderField();
    	});
    },
    
    resetAccountHolderField: function() {
    	var labelSelector = 'label[for="ach_account_holder_validator"]';
    	$(labelSelector).removeClass('error');		
		$(labelSelector).addClass('hide');		
		if($("#ach_account_holder").prop("readonly")) {
			$(labelSelector).html("");
			$("#ach_account_holder").removeAttr("disabled");
			$("#ach_account_holder").removeAttr("readonly");
			TokenGateway.resetACHFields($("#ach_account_number"), $("#ach_routing_number"), "ach_account_holder");
		}
		$("#ach_account_holder").focus();
		
    },
    
    
    /**
     * Shows Credit Card section on user radio selection
     */
    showCCSection: function() {
    	$('#radio-credit-card').prop('checked', true);
    	$('#PaymentMethodForm #payment_type').val('CreditCard');
    	$('#ach-payment-block').addClass('hide');
        $('#cc-payment-block').removeClass('hide');
        PaymentMethods.removeBorderErrors();
        PaymentMethods.setupSelectedFormSection('CreditCard');
        if(this.cybersourceEnabled) {
        	PaymentMethods.removeRules(PaymentMethods.achCybsValidationRules);
        } else {
        	PaymentMethods.removeRules(PaymentMethods.achValidationRules);
        }
        
        var isPharmacy = $('input[name="isPharmacy"]').val();
        if(isPharmacy){
        	if(this.cybersourceEnabled) {
        		PaymentMethods.addCybersourceRules(PaymentMethods.pharmacyCreditCardCybsValidationRules);
        	} else {
        		PaymentMethods.addRules(PaymentMethods.pharmacyCreditCardValidationRules);
        	}
        } else { 
        	if(this.cybersourceEnabled) {
        		PaymentMethods.addCybersourceRules(PaymentMethods.creditCardCybsValidationRules);
        	} else {
        		PaymentMethods.addRules(PaymentMethods.creditCardValidationRules);
        	}
        }
        
    },
    selectACHPayment: function() {
    	if(this.cybersourceEnabled) {
      	  createTokenSessionId(false, false);
        }
    	PaymentMethods.showACHSection();
    	if (this.cybersourceEnabled) {
          this.setACHInputFieldsEvents();
        }
    },
    /**
     * Shows ACH section on user radio selection (BD only)
     */
    showACHSection: function() {
    	$('#radio-ach').prop('checked', true);
    	$('#PaymentMethodForm #payment_type').val('ACH');
    	$('#ach-payment-block').removeClass('hide');
        $('#cc-payment-block').addClass('hide');
        PaymentMethods.removeBorderErrors();
        PaymentMethods.setupSelectedFormSection('ACH');
        if(this.cybersourceEnabled) {
        	PaymentMethods.removeRules(PaymentMethods.creditCardCybsValidationRules);
            PaymentMethods.addRules(PaymentMethods.achCybsValidationRules);
        } else {
        	PaymentMethods.removeRules(PaymentMethods.creditCardValidationRules);
            PaymentMethods.addRules(PaymentMethods.achValidationRules);
        }        
    },
    
    /** Changes for Cybersource Integration starts here **/
    
    addCybersourceRules: function(rulesObj) {
    	for (var item in rulesObj) {
    		if (item == 'accountType') {
        		$('select[name='+ item + ']').rules('add',rulesObj[item]);  
        	} else {
        		$('input[name='+ item + ']').rules('add',rulesObj[item]);  
        	}
        } 
    },
    
    creditCardCybsValidationRules: {
    	nameOnCard: {
	      required: true,
	      checkSpecialchar: true,
	      messages: {
	    	  required: messages.ERR_NAME_REQ,
	          checkSpecialchar: messages.ERR_INVALID_CC_NAME
	      }
	    },
	    cc_expiry_date: {
	      required: true,
	      checkExpiryDate: true,
	      checkIsDateInPast: true,
	      messages: {
	    	  required: messages.ERR_EXPIRYDATE_REQ,
	          checkExpiryDate: messages.ACCOUNT_PAYMENT_METHODS_ERR_INVALID_DATE,
	          checkIsDateInPast: messages.ERR_INVALID_PAST_DATE
	      }
	    }
	},
	pharmacyCreditCardCybsValidationRules: {
		nameOnCard: {
	      required: true,
	      checkSpecialchar: true,
	      messages: {
	    	  required: messages.ERR_PH_NAME_REQ,
	          checkSpecialchar: messages.ERR_INVALID_CC_NAME
	      }
	    },
	    cc_expiry_date: {
	      required: true,
	      checkExpiryDate: true,
	      checkIsDateInPast: true,
	      messages: {
	    	  required: messages.ERR_PH_EXPIRYDATE_REQ,
	          checkExpiryDate: messages.ACCOUNT_PAYMENT_METHODS_ERR_INVALID_DATE,
	          checkIsDateInPast: messages.ERR_INVALID_PAST_DATE
	      }
	    }
	},
  };

  if (typeof window.COSTCO === 'undefined') {
    window.COSTCO = {};
  }

  window.COSTCO.PaymentMethods = PaymentMethods;

  return PaymentMethods;
});



// WEBPACK FOOTER //
// ./js/account/payment-methods.js